import './NotFound.css';
import React from 'react';
import Navbar from '../Shared/Navbar/Navbar';
import AOS from 'aos';

const NotFound = () => {

      AOS.init();

      return (
            <div style={{height:'100vh',backgroundColor:'#00101f'}} className='not-found'>
                  <Navbar />
                  <div data-aos="fade-down" className="container mx-auto d-block mt-5">
                        <img src='https://i.ibb.co/kJ1bHwm/portfolio.png' className='img-fluid mx-auto d-block' width={300} style={{ borderRadius: '50%' }} alt="" />
                  </div>
                  <h1 style={{fontSize:'8rem'}} className='text-center mt-2 brand fw-bold'>4 0 4</h1>
                  <h2 className='text-center text-white fw-bold mt-3'>There's NOTHING here...</h2>
                  <p className='text-center text-white fw-bold mt-2'>Maybe the page you're looking for is not found or never existed</p>
                  <a className='text-decoration-none' href="/">
                  <button className='btn hvr-sweep-to-bottom mx-auto d-block mt-2 text-white'><i class="fas fa-home"></i> Back To Home</button>
                  </a>
            </div>
      );
};

export default NotFound;